<template>
  <div id="bedrooms-list">
    <SidebarLayout2
      :breadcrumb="breadcrumb"
      pageTitle="Agrupador de produtos e serviços"
    >
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading>
            Ações da página
          </Heading>

          <!-- CADASTRAR -->
          <Button
            :hasIcon="true"
            class="page-actions--button"
            @click="$router.push({ path: '/agrupador-produtos/novo' })"
          >
            Criar agrupador
          </Button>
          <Button
            :disabled="disableEditButton"
            class="page-actions--button"
            @click.stop.prevent="
              $router.push({
                path: `agrupador-produtos/editar/${selectedRows[0].codigo}`
              })
            "
          >
            Editar
          </Button>
          <Button
            :disabled="disabledDeleteButton"
            variation="error"
            class="page-actions--button"
            @click.stop.prevent="deleteModal(selectedRows.codigo)"
          >
            Excluir
          </Button>
        </SidebarBlock>

        <!-- DICAS -->
        <SidebarBlock>
          <Heading>
            Dica
          </Heading>
          <Paragraph class="page-actions--tip-text">
            Crie grupos para categorizar produtos e serviços, permitindo uma
            análise consolidada do desempenho de vendas e da lucratividade por
            tipo de produto. <br /><br />
            <strong>Exemplo:</strong> Analisar o impacto de vendas no spa,
            pacotes românticos, estacionamento ou aluguel de equipamentos na
            receita total do hotel, identificando quais ofertas são mais
            populares e rentáveis.
          </Paragraph>
        </SidebarBlock>
      </template>

      <!-- CONTEÚDO -->
      <template #content>
        <div class="filters">
          <!-- BUSCA -->
          <SearchInput v-model="filterByName" class="filters--search-input" />
        </div>

        <!-- TABELA -->
        <DataTable
          :cols="cols"
          :sortable="true"
          :isLoading="loading"
          :rows="rows"
          :selectableRow="true"
          :colsMinWidths="minWidths"
          ref="dataTable"
          maxHeight="1080"
          class="datatable"
          @getSelectedRows="selectedRows = $event"
        >
          <template v-slot:nome="data">
            {{ data.rowDataObj.nome }}

            <button
              class="datatable--info-button"
              @click.stop.prevent="buttonInfo(data.rowDataObj.codigo)"
            >
              <div
                v-if="
                  loadingBundlerData &&
                    detailItemCode === data.rowDataObj.codigo
                "
                class="info-loader"
              ></div>

              <Icon v-else icon="info" class="info-icon" />
            </button>
          </template>
          <template v-slot:editar="data">
            <div>
              <button
                class="datatable--link__edit"
                @click.stop.prevent="
                  $router.push({
                    path: `agrupador-produtos/editar/${data.rowDataObj.codigo}`
                  })
                "
              >
                Editar
              </button>
            </div>
          </template>
        </DataTable>
        <!-- PAGINAÇÃO -->
        <PmwPagination
          :items="filterTable"
          :itemsPerPage="pagination.itemsPerPage"
          :currentPage="pagination.currentPage"
          :totalItems="filterTable.length"
          :itemsPerPageOptions="pagination.itemsPerPageOptions"
          @changePagination="changePagination"
        />
        <!-- MODAL DELEÇÃO -->
        <AlertModal
          v-model="showDeleteModal"
          :buttonClose="true"
          title="Excluir agrupador de produtos e serviços"
          @alert-modal-cancel="cancelDisable()"
          @alert-modal-confirm="disableBundler()"
        >
          <template #text>
            Ao excluir esse agrupador, não será mais possível visualizar as
            informações contidas nele de forma compilada em relatórios. <br />
            Tem certeza de que quer fazer isso?
          </template>
        </AlertModal>

        <Modal
          v-model="modalTable"
          :hasFooter="false"
          :width="'auto'"
          :smallerHeader="true"
          :smallHeader="true"
          :title="title"
          id="modal"
          class="modal"
          @modal-cancel="clearSelected()"
          @modal-close="detailItemCode = null"
        >
          <template slot="body-content">
            <div class="modalInfo">
              <div class="row">
                <div v-if="detailTableRows.length > 0" class="col modal-spaces">
                  <CleanTable
                    :columns="detailTableColumns"
                    :rows="detailTableRows"
                  />
                </div>
                <div v-else>
                  Não existem extras cadastrados neste agrupador
                </div>
              </div>
            </div>
          </template>
        </Modal>
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
/** Componentes da lib */
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import PmwPagination from '@solucoes/components-lib-tmp/src/components/patterns/PmwPagination'
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput'
import Icon from '@solucoes/components-lib-tmp/src/components/elements/Icon'
import Paragraph from '@solucoes/components-lib-tmp/src/components/elements/Paragraph'
import Modal from '@solucoes/components-lib-tmp/src/components/patterns/Modal'
import CleanTable from '@solucoes/components-lib-tmp/src/components/patterns/CleanTable'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'

/** Imports do projeto */
import SidebarLayout2 from '@/layouts/SidebarLayout2'

export default {
  name: 'rateBundlerList',
  components: {
    AlertModal,
    Button,
    DataTable,
    Heading,
    PmwPagination,
    SearchInput,
    Icon,
    Paragraph,
    Modal,
    CleanTable,
    SidebarLayout2,
    SidebarBlock
  },
  data() {
    return {
      /** valores da tabela de informações */
      detailTableColumns: [
        {
          label: 'Produtos',
          value: 'nome',
          name: 'nome'
        }
      ],
      detailTableRows: [],
      detailItemCode: null,
      /** ------------------- */
      breadcrumb: [
        {
          label: 'Configurações'
        },
        {
          label: 'Agrupador de produtos e serviços'
        }
      ],

      minWidths: {
        editar: '75px'
      },

      /** Colunas da tabela */
      cols: [
        {
          alias: 'Nome',
          name: 'nome'
        },
        {
          alias: 'Ações',
          name: 'editar'
        }
      ],
      /** V-model da busca */
      filterByName: '',
      /** Dados da paginação */
      pagination: {
        totalItems: 0,
        currentPage: 1,
        itemsPerPage: 25,
        startItemIndex: 1,
        lastItemIndex: 25,
        itemsPerPageOptions: [
          {
            text: '25',
            value: 25
          },
          {
            text: '50',
            value: 50
          },
          {
            text: '75',
            value: 75
          },
          {
            text: '100',
            value: 100
          }
        ]
      },
      /** Linhas da tabela (dados) */
      rows: [],
      /** Armazena dados de retorno */
      allRates: [],
      /** Loading da tabela */
      loading: true,
      /** Array das linhas selecionadas */
      selectedRows: [],
      /** Usuário a ser deletado */
      bundlerToDisable: null,
      /** Titulo da tabela selecionada */
      title: null,
      /** Exibição da modal de deleção */
      showDeleteModal: false,
      modalTable: false,
      agrupadorSelecionado: null,
      loadingBundlerData: false
    }
  },
  computed: {
    /** Desabilita botão de deletar */
    disabledDeleteButton() {
      if (this.selectedRows.length >= 1) {
        return false
      }
      return true
    },

    /** Desabilita botão de editar */
    disableEditButton() {
      if (this.selectedRows.length === 1) {
        return false
      }
      return true
    },

    /** Filtro de pesquisa da tabela */
    filterTable() {
      const results = this.allRates.filter((data) => {
        return (
          data.nome.toLowerCase().indexOf(this.filterByName.toLowerCase()) > -1
        )
      })
      return results
    }
  },
  created() {
    /** Faz a chamada da api */
    this.getBundlers()
  },
  methods: {
    /**
     * Ação do botão de informação
     * @param {Number} codigo - Código do agrupador
     */
    buttonInfo(codigo) {
      this.detailItemCode = codigo
      this.getBundler(codigo)
      this.agrupadorSelecionado = codigo
    },

    /** Retorna dados da listagem */
    getBundlers() {
      this.loading = true
      this.$productsAndServicesBundler.get().then(({ data }) => {
        const results = data

        results.map(function(key, index) {
          results[index]['data'] = {
            nome: key.nome,
            codigo: key.codigo,
            produtos: key.produtos
          }
        })
        this.allRates = results
      })
      this.loading = false
    },

    /**
     * Retorna dados do agrupador
     * @param {Number} codigo - Código do agrupador
     */
    getBundler(codigo) {
      if (this.loadingBundlerData) return

      this.loadingBundlerData = true

      this.$productsAndServicesBundler
        .get(codigo)
        .then(({ data }) => {
          this.modalTable = true

          const single = data.produtos
          this.title = data.nome

          if (single.length > 0) {
            single.map(function(item) {
              return item
            })

            this.detailTableRows = single
          } else {
            this.detailTableRows = []
          }
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Não foi possível carregar os dados do agrupador.'
          })
          this.modalTable = false
        })
        .finally(() => {
          this.loadingBundlerData = false
        })
    },

    /** Desabilitar agrupador */
    disableBundler() {
      const deleteProductsBundler = this.ifExists(
        this.selectedRows.length > 0
          ? this.selectedRows.map((item) => {
              return parseInt(item.codigo)
            })
          : [this.bundlerToDisable]
      )

      this.$productsAndServicesBundler
        .delete(deleteProductsBundler)
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de produtos e serviços excluido com sucesso'
          })
          this.getBundlers()
          this.resetPagination()
          this.selectedRows = []
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao desativar agrupador de produtos e serviços'
          })
        })
    },

    /**
     * Controle de deleção
     * @param {Number} bundlerId - Código do agrupador
     */
    deleteModal(bundlerId) {
      this.showDeleteModal = true
      this.bundlerToDisable = bundlerId
    },

    /** Cancela deleção */
    cancelDisable() {
      this.showDeleteModal = false
      this.bundlerToDisable = null
    },

    /**
     * Verificar se dado existe
     * @param {Object} element - Dado a ser verificado
     */
    ifExists(element) {
      /** se for array */
      let result = null
      if (element && typeof element.value !== 'undefined') {
        result = element.value
        /** se for string */
      } else if (element !== '') {
        result = element
      }
      return result === true ? 1 : result
    },

    /**
     * Usado para controle da paginação
     * @param {Object} childData - Dados da paginação
     */
    changePagination(childData) {
      this.pagination.currentPage = childData.currentPage
      this.rows = childData.items
    },

    /** Reseta dados da paginação */
    resetPagination() {
      this.pagination.currentPage = 1
      this.pagination.startItemIndex = 1
      this.pagination.itemsPerPage = 25
      this.pagination.lastItemIndex = this.pagination.itemsPerPage
    },

    /** Limpa agrupador selecionado */
    clearSelected() {
      this.agrupadorSelecionado = null
      this.title = null
      this.detailTableRows = []
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  pointer-events: none;
}
::v-deep .content {
  /** Padding abaixo do título da página */
  .page-heading {
    padding-bottom: 24px;
  }
}
::v-deep .datable-grid-wrapper {
  .col {
    padding-left: 14px;
  }
}
.sidebar {
  &-title {
    color: pmw-colors('grey-90');
    margin-top: 35px;
    margin-bottom: 15px;
    margin-left: 15px;
    max-width: 215px;
  }
  &-tip-title {
    color: pmw-colors('grey-90');
    margin-top: 35px;
    max-width: 215px;
  }
  &-tip-text {
    color: pmw-colors('grey-90');
    font-size: pmw-font-size('paragraph-60');
    line-height: 21px;
    max-width: 215px;
  }
  &-buttons {
    display: flex;
    flex-direction: column;
    margin-bottom: 50px;
    width: 215px;
    gap: 10px;
    margin: auto;
  }
}
.filters {
  display: flex;
  gap: 20px;
  margin-bottom: 40px;

  &--search-input {
    width: 215px;
  }

  &--more {
    width: 225px;
  }
}

.links {
  border: none;
  background-color: inherit;
  &.edit {
    color: pmw-colors('blue-100');
  }
  &.delete {
    color: map-get($pmw-old-colors, 'pmw-error');
  }
}
.datatable {
  &--info-button {
    background-color: transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    overflow: hidden;
    outline: none;
  }
  &--link {
    &__edit {
      border: none;
      background-color: inherit;
      color: pmw-colors('blue-100');
    }
    &__delete {
      border: none;
      background-color: inherit;
      color: map-get($pmw-old-colors, 'pmw-error');
    }
  }
  ::v-deep {
    .pmw-col.pmw-th:nth-child(3) {
      pointer-events: none;
      max-width: 20px;
      .pmw-sort-icons {
        display: none;
      }
      .pmw-label {
        margin-left: 5px;
      }
    }
    .pmw-col.pmw-td:nth-child(3) {
      max-width: 25px;
      .pmw-sort-icons {
        display: none;
      }
    }
  }
}
.info-icon {
  margin-left: 5px;
  height: 15px;
  width: 15px;
  color: map-get($pmw-old-colors, 'pmw-gray-dark');
  transition: color $pmw-color-anim linear;

  &:hover {
    color: $pmw-blue;
  }
}
button:focus {
  outline: none;
  outline: 0px;
}
.modalInfo {
  padding: 25px;
}
#modal {
  :v-deep {
    section.modal-component--header {
      padding: 0px;
    }
  }
}
.page-actions {
  padding-top: 50px;
  &--button {
    width: 100%;
    cursor: pointer;

    & + .page-actions--button {
      margin-top: 10px;
    }
  }
  &--tip-text {
    color: pmw-colors('grey-90');
    font-size: pmw-font-size('paragraph-60');
    line-height: 21px;
    max-width: 215px;
  }
}

.info-loader {
  @include pmw-loader($size: 15px, $border-size: 4px);
  margin-left: 5px;
}
</style>
